module.exports = __webpack_public_path__ + "img/mb-lines-svg-2.df328748.svg";